export default __webpack_public_path__ + "static/promo-text-fd31b91a37167bf66a93e2824b8425b2.svg";